'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _colors = require('../../../constants/colors');

var _helpers = require('../helpers');

var _helpers2 = _interopRequireDefault(_helpers);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SpinnerIcon = function SpinnerIcon(props) {
    return _react2.default.createElement(
        'svg',
        props,
        _react2.default.createElement(
            'circle',
            {
                cx: '50',
                cy: '50',
                fill: 'none',
                stroke: '{`{`}{`{`}props.stroke{`}`}{`}`}',
                strokeWidth: '6',
                r: '20',
                strokeDasharray: '94.24777960769379 33.41592653589793',
                transform: 'rotate(72 50 50)'
            },
            _react2.default.createElement('animateTransform', {
                attributeName: 'transform',
                type: 'rotate',
                calcMode: 'linear',
                values: '0 50 50;360 50 50',
                keyTimes: '0;1',
                dur: '1.5s',
                begin: '0s',
                repeatCount: 'indefinite'
            })
        )
    );
};

SpinnerIcon.defaultProps = {
    xmlns: 'http://www.w3.org/2000/svg',
    viewBox: '0 0 100 100',
    preserveAspectRatio: 'xMidYMid',
    className: 'lds-rolling'
};

var Spinner = function (_React$Component) {
    _inherits(Spinner, _React$Component);

    function Spinner() {
        _classCallCheck(this, Spinner);

        return _possibleConstructorReturn(this, (Spinner.__proto__ || Object.getPrototypeOf(Spinner)).apply(this, arguments));
    }

    _createClass(Spinner, [{
        key: 'render',
        value: function render() {

            var size = this.props.size || 'medium';

            size = (0, _helpers2.default)(size);

            return _react2.default.createElement(SpinnerIcon, { width: size.width + 'px', height: size.height + 'px', stroke: _colors.Colors.Primary });
        }
    }]);

    return Spinner;
}(_react2.default.Component);

exports.default = Spinner;